import { ModelBase } from 'store/model-base';
import { DenialVideoResolutionReasons, ResolutionStatus } from 'core/constants';

export class VideoResolutionInfo extends ModelBase {
    public static storeName: string = 'videoResolution';

    public lineId: string;
    public toggleEligibility: boolean;
    public currentResolution: string;
    public denialReasons: DenialReasons[];
    public isHighDefinition: boolean;
    public isStandardDefinition: boolean;
    public isPendingDenialState: boolean;
    public isVideoToggleEligible: boolean;

    public static create<T extends ModelBase>(toReturn: ApiResponse): T {
        toReturn.isHighDefinition = toReturn.currentResolution === ResolutionStatus.HIGH;
        toReturn.isStandardDefinition = toReturn.currentResolution === ResolutionStatus.LOW;
        toReturn.isPendingDenialState = Array.isArray(toReturn.denialReasons) && Boolean(toReturn.denialReasons.length) 
            && toReturn.denialReasons.every((reason: DenialReasons) => reason.code === DenialVideoResolutionReasons.VIDRESELIG_PENDING_ORDER);
        toReturn.isVideoToggleEligible = toReturn.toggleEligibility || toReturn.denialReasons.some((reason: DenialReasons) => !(
            reason.code === DenialVideoResolutionReasons.VIDRESELIG_INVALID_SEGMENT
            || reason.code === DenialVideoResolutionReasons.VIDRESELIG_LINE_INACTIVE
            || reason.code === DenialVideoResolutionReasons.VIDRESELIG_INVALID_DEVICE
            || reason.code === DenialVideoResolutionReasons.VIDRESELIG_INVALID_RATEPLAN
        ));

        return super.create<T>(toReturn);
    }
}
